export const installModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '98%',
  height: '95dvh',
  bgcolor: 'background.paper',
  borderRadius: '12px',
  zIndex: 900,
  boxShadow: 24,
  p: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}
